import { render } from "./SpareLedger.vue?vue&type=template&id=d51525a4&scoped=true"
import script from "./SpareLedger.vue?vue&type=script&lang=js"
export * from "./SpareLedger.vue?vue&type=script&lang=js"

import "./SpareLedger.vue?vue&type=style&index=0&id=d51525a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d51525a4"]])

export default __exports__